// extracted by mini-css-extract-plugin
export default {"grid_box":"aboutUs_grid_box__C4+-r","namu_logo":"aboutUs_namu_logo__UK0Ji"};